// extracted by mini-css-extract-plugin
export default {"cls1":"AboutTheAuthorsSection-cls1_RPO","cls2":"AboutTheAuthorsSection-cls2_i6T AboutTheAuthorsSection-cls1_RPO"};